import type { NotificationV2Payload } from '@/types/apps/notification-v2.type';
import type { NotificationResponse } from '@/types/apps/notification.type';
import type { ApiResponse, PaginatedResult } from '@/types/common/api.type';
import type { BaseApiClientInterface } from '@/types/service/base-api-client.interface';
import type { Indexable } from '@/types/service/indexable.interface';

type NotificationV2ListResponse = ApiResponse<
    PaginatedResult<NotificationResponse>
>;

export class NotificationV2Service implements Indexable {
    public constructor(private apiClient: BaseApiClientInterface) {}

    protected endpoints = {
        markAsRead: () => `/api/v2/notifications/mark-all-as-read`,
    };

    public markAsRead(
        payload: NotificationV2Payload
    ): Promise<ApiResponse<NotificationV2ListResponse>> {
        return this.apiClient.postApi(this.endpoints.markAsRead(), payload);
    }
}
